<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    上沙站<br>
站点介绍<br>
7号线上沙站位于深圳市福强路，车站沿福强路主干道中心布设，呈十字形布置。东侧为益田路；南侧有福田体育公园；西侧为上沙花园，有上沙龙秋路；车站东南侧是乐安居；北侧为星业五金商行，有彩达楼。车站位于福强路上，东侧为滨河大道，南侧为沙嘴路，西侧为上沙大道，北侧为十七号街。上沙站装修以橙黄色及米白色为主色调，柱面采用搪瓷钢板。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:34	23:33	7号线	3分35秒	5分55秒<br>
太安	06:03	23:24	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:27	23:33	7号线	4分钟	5分55秒<br>
太安	06:09	23:24	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:27	00:33	7号线	4分钟	5分55秒<br>
太安	06:09	00:24	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
福强路南侧（西）、上沙龙秋村<br><br>
B出入口:<br>
上沙村、上沙幼儿园、上沙小学、上沙中学、上沙文化广场、上沙花园、福民新苑<br><br>
C出入口:<br>
乐安居、福强路南侧（东）、沙嘴路西侧(南）、金海湾花园、金地工业区、贵发大厦、沙头派出所、好景豪园、金地花园<br><br>
D出入口:<br>
福强路北侧（东）、沙嘴路西侧 （北）、怡和楼、椰树花园、税务综合大楼、沙尾综合楼、金沙花园、金沙嘴大厦、深圳绿洲小学、新洲中学、香江西苑、福瑞阁、韵动家园、中央西谷大厦、福田分局经侦大队<br><br>
E出入口:<br>
福强路北侧（西）、福田体育公园、荔树人家<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 上沙村<br>
44路,71路,80路,103路,202路,M172路（原372路）,317路,322路,339路,B689路, M347路,215路,M433路，M453路，M500路，M519路；303路，M559路<br><br>
D出入口:<br>
公交站名： 上沙村①<br>
80路，322路，339路，377路，M347路，M453路<br><br>
E出入口:<br>
公交站名： 上沙村②<br>
362路,317路,B689路,M433路,M500路,M519路,202路,303路,44路，M172路（原372路），26路，71路，215路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>